<!--
 * @Description: 
 * @Author: 长老
 * @Date: 2019-07-23 16:06:51
 * @lastTime     : 2020-01-10 15:23:51
 * @LastAuthor   : WE1ZHANTA0
 -->
<template>
  <div class="shade-cont-team" v-if="leaderDetails">
    <div class="shade-box">
      <div class="shade-box-s">
        <div class="shade-tuan ui-rows-wrap">
          <div class="shade-pic ui-cols-center"><img class="comm-pic" :src="leaderDetails.leaderUrl" alt=""><img class="icon-tuan" src="//static.yunjiglobal.com/qnUpload/frontend/groupon/icon-tuan.png" alt=""></div>
          <div class="shade-right rigth-1 ui-cols-center">
            <div class="r-tip1 ui-nowrap-one">
              <span class="leader-name ui-nowrap-one">{{leaderDetails.leaderName}}</span>
              <!-- <span class="lead-price">
                <i v-if="leaderDetails.leaderType ==1">共赚</i>
                <i v-else>已省</i> {{leaderDetails.totalIncome}}元
              </!-->
            </div>
            <p class="r-tip2">{{YunJi.filterFormatDate(leaderDetails.createTime, 'yyyy.MM.dd hh:mm:ss')}}</p>
             <!-- groupbuyTypeToggle 0-关 1-开 -->
            <p class="r-tip4" v-if='leaderDetails.groupbuyTypeToggle == 1'><span v-if="leaderDetails.type == 0">我要团</span><span v-if="leaderDetails.type == 1">分享团</span></p>
          </div>
        </div>
        <ul class="shade-list">
          <li class="shade-tuanli ui-rows-wrap" v-show="leaderDetails.singles && leaderDetails.singles.length > 0" v-for="(item,index) in leaderDetails.singles" :key='index'>
            <div class="shade-pic-c ui-cols-center"><img class="comm-pic-c" :src="item.playerUrl" alt=""></div>
            <div class="shade-right rigth-2 ui-cols-center">
              <div class="r-tip1 r-10">{{item.playerName}}<img class="icon-vip" src="//static.yunjiglobal.com/qnUpload/frontend/groupon/icon-vip.png" alt="" v-if="item.playerType == 1">
                <!-- <span class="lead-price1" v-if="item.playerType !=1 && leaderDetails.leaderType == 1">赚 {{item.income}}元</span> -->
              </div>
              <div class="r-tip3">{{YunJi.filterFormatDate(item.createTime, 'yyyy.MM.dd hh:mm:ss')}}<span>拼团</span></div>
            </div>
          </li>
        </ul>
      </div>
      <span class="shade-close" @click="close"></span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'teamList',
  data() {
    return {
      // leaderDetails: null, // 团长信息
    }
  },
  props: {
    groupbuyId: {
      type: String,
      default() {
        return ''
      }
    },
    leaderDetails: {
      type: Object,
      default() {
        return { }
      }
    }
  },
  created() {

  },
  mounted() {
    // document.getElementsByClassName('shade-cont-team')[0].addEventListener('touchmove', (e)=>{
    //   e.preventDefault()
    // })
  },
  methods: {
    close() {
      thinkingReport.track('others', {
        page_id: this.$parent.pageId,
        operation_name: 'btn_关闭'
      })
      this.$parent.isShowTeam = false
      // this.$parent.closeDefault()
      document.body.style.overflow = 'auto'
    }
    
  }
}
</script>
<style scoped lang="stylus">
  .shade-cont-team
    position fixed
    width 100%
    height 100%
    background rgba(0, 0 ,0, 0.7) !important
    top 0
    left 0
    z-index 999
    display flex
    align-items center
    .shade-box
      width 5.8rem
      position relative
      top 1rem
      left 50%
      margin-left -2.95rem
      .shade-box-s
        height 7.2rem
        background #F8F8F8
        border-radius .16rem
        .shade-tuan
          height 1.68rem
          padding-top .3rem
          background #fff
          border-radius .16rem .16rem 0 0
        .shade-tuan, shade-list, .shade-tuanli
          width 100%
          padding-left .24rem
          padding-right .24rem
          .shade-pic
            width 1rem
            height 1rem
          .shade-pic-c
            width .84rem
            height .84rem
          .shade-pic, .shade-pic-c
            // background url('//static.yunjiglobal.com/qnUpload/frontend/groupon/touxian-bg.png') no-repeat
            // background-size 100%
            position relative
            .comm-pic
              width .96rem
              height .96rem
            .comm-pic-c
              width .8rem
              height .8rem
            .comm-pic, .comm-pic-c
              border-radius 50%
              padding .02rem
            .icon-tuan
              position absolute
              width .52rem
              height .28rem
              bottom -.08rem
              left 50%
              margin-left -.26rem
          .rigth-1
            margin-left .16rem
          .rigth-2
            margin-left .32rem
          .shade-right
            width 4.1rem
            .r-tip1
              font-size .28rem
              color rgba(0,0,0,0.65)
              // margin-top .1rem
              min-height .38rem
              .leader-name
                display inline-block
                width 2.2rem
              .lead-price
                color #F10D3B
                float right
              .lead-price1
                color #333
                float right
              .lead-price
                font-weight 700
                i
                  font-weight 700
              .icon-vip
                width .88rem
                height .28rem
                margin-left .08rem
            .r-10
              margin-top .08rem
            .r-tip4
              line-height .28rem 
              font-size .2rem
              color rgba(0,0,0,0.45)
              font-family: PingFangSC-Medium;
              font-size: 0.2rem;
              color: #333333;
              line-height: 0.2rem;
              margin-top 0.16rem
            .r-tip2,.r-tip3
              line-height .28rem 
              font-size .2rem
              color rgba(0,0,0,0.45)
                
            .r-tip3
              margin-top .08rem
              span 
                margin-left .12rem
        .shade-list
          margin-top .24rem
          height 5rem
          overflow auto
          .shade-tuanli
            box-sizing: border-box;
            height 1rem
            margin-bottom .2rem
      .shade-close
        margin .7rem auto 0 auto
        display block
        width .64rem
        height .64rem
        background url('//static.yunjiglobal.com/qnUpload/frontend/groupon/guanbi-190603.png') no-repeat
        background-size 100%


</style>
